import {
  curry, lensPath, path, set,
} from 'ramda';

export const getEventValue = path(['target', 'value']);

export default curry((element, statePath, event) => {
  const lens = lensPath(statePath);
  const value = getEventValue(event);
  const update = set(lens, value, {});

  element.setState(update);
});
